import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-[7px] text-[12.5px] font-semibold transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:bg-[#E6E2D9] disabled:text-[#A29D93] disabled:border-[#D3CEC2] disabled:shadow-none [&_svg]:pointer-events-none [&_svg]:size-3.5 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-[#FFD108] border border-[#E0B800] text-black font-bold uppercase tracking-[0.04em] hover:bg-[#E5B93D]",
        destructive:
          "bg-[#D93526] border border-[#B8291C] text-white hover:bg-[#c22d20]",
        outline:
          "bg-white border border-[#C9C3B6] text-[#1A1A1A] hover:bg-[#FBFAF7]",
        secondary:
          "bg-[#F2F0EA] border border-[#E2DED4] text-[#1A1A1A] hover:bg-[#E9E6DE]",
        ghost: "text-[#1A1A1A] hover:bg-[#F0EDE7]",
        link: "text-[#8A6D00] normal-case tracking-normal underline-offset-4 hover:underline",
      },
      size: {
        default: "h-[34px] px-3",
        sm: "h-7 px-2.5 text-[11px]",
        lg: "h-9 px-4",
        icon: "h-8 w-8",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
